import React from 'react';

import './DetailLayout.scss';

interface DetailLayoutProps {
    sidebarContent: React.ReactNode;
    primaryContent: React.ReactNode;
}

export default function DetailLayout({ sidebarContent, primaryContent }: DetailLayoutProps) {
    return (
        <div className="detail-layout">
            <aside className="detail-layout__sidebar">{sidebarContent}</aside>
            <div className="detail-layout__main">{primaryContent}</div>
        </div>
    );
}
